/**
 * Libellés ag-grid en français.
 * Ne pas utiliser directement : passer par getLocaleText() de grid-locale.ts,
 * qui sélectionne la table correspondant à la langue courante.
 */
export const frLocaleText = {
  // Set Filter
  selectAll: "Tout sélectionner",
  selectAllSearchResults: "Sélectionner tous les résultats",
  searchOoo: "Rechercher...",
  blanks: "(Vides)",
  noMatches: "Aucun résultat.",

  // Number Filter & Text Filter
  filterOoo: "Filtre...",
  equals: "Égal",
  notEqual: "Différent",

  // Number Filter
  lessThan: "Plus petit",
  greaterThan: "Plus grand",
  lessThanOrEqual: "Plus petit ou égal",
  greaterThanOrEqual: "Plus grand ou égal",
  inRange: "Compris entre",
  inRangeStart: "De",
  inRangeEnd: "à",

  // Text Filter
  contains: "Contient",
  notContains: "Ne contient pas",
  startsWith: "Commence par",
  endsWith: "Se termine par",

  // Date Filter
  dateFormatOoo: "aaaa-mm-jj",

  // Filter Conditions
  andCondition: "ET",
  orCondition: "OU",

  // Filter Buttons
  applyFilter: "Appliquer",
  resetFilter: "Réinitialiser",
  clearFilter: "Effacer",
  cancelFilter: "Annuler",

  // Side Bar
  columns: "Colonnes",
  filters: "Filtres",

  // columns tool panel
  pivotMode: "Mode pivot",
  groups: "Groupes de lignes",
  rowGroupColumnsEmptyMessage: "Glissez ici pour grouper les lignes",
  values: "Valeurs",
  valueColumnsEmptyMessage: "Glissez ici pour agréger",
  pivots: "Libellés de colonnes",
  pivotColumnsEmptyMessage: "Glissez ici pour définir les libellés de colonnes",

  // Header of the Default Group Column
  group: "Groupe",

  // Other
  loadingOoo: "Chargement...",
  noRowsToShow: "Aucune donnée existante.",
  enabled: "Activé",

  // Menu
  pinColumn: "Épingler la colonne",
  pinLeft: "Épingler à gauche",
  pinRight: "Épingler à droite",
  noPin: "Ne pas épingler",
  valueAggregation: "Agrégation des valeurs",
  autosizeThiscolumn: "Ajuster cette colonne",
  autosizeAllColumns: "Ajuster toutes les colonnes",
  groupBy: "Grouper par",
  ungroupBy: "Dégrouper par",
  resetColumns: "Réinitialiser les colonnes",
  expandAll: "Tout déplier",
  collapseAll: "Tout replier",
  copy: "Copier",
  ctrlC: "Ctrl+C",
  copyWithHeaders: "Copier avec les en-têtes",
  paste: "Coller",
  ctrlV: "Ctrl+V",
  export: "Exporter",
  csvExport: "Export CSV",
  excelExport: "Export Excel (.xlsx)",
  excelXmlExport: "Export Excel (.xml)",

  // Enterprise Menu Aggregation and Status Bar
  sum: "Somme",
  min: "Min",
  max: "Max",
  none: "Aucun",
  count: "Nombre",
  avg: "Moyenne",
  filteredRows: "Filtrées",
  selectedRows: "Sélectionnées",
  totalRows: "Total de lignes",
  totalAndFilteredRows: "Lignes",
  page: "Page",
  more: "Plus",
  to: "à",
  of: "sur",
  next: "Suivant",
  last: "Dernier",
  first: "Premier",
  previous: "Précédent",

  // Enterprise Menu (Charts)
  pivotChartAndPivotMode: "Graphique croisé & mode pivot",
  pivotChart: "Graphique croisé",
  chartRange: "Plage du graphique",

  columnChart: "Colonnes",
  groupedColumn: "Groupées",
  stackedColumn: "Empilées",
  normalizedColumn: "Empilées à 100 %",

  barChart: "Barres",
  groupedBar: "Groupées",
  stackedBar: "Empilées",
  normalizedBar: "Empilées à 100 %",

  pieChart: "Camembert",
  pie: "Camembert",
  doughnut: "Anneau",

  line: "Courbe",

  xyChart: "X Y (nuage de points)",
  scatter: "Nuage de points",
  bubble: "Bulles",

  areaChart: "Aires",
  area: "Aires",
  stackedArea: "Empilées",
  normalizedArea: "Empilées à 100 %",

  histogramChart: "Histogramme",

  // Charts
  pivotChartTitle: "Graphique croisé",
  rangeChartTitle: "Graphique de plage",
  settings: "Paramètres",
  data: "Données",
  format: "Format",
  categories: "Catégories",
  defaultCategory: "(Aucune)",
  series: "Séries",
  xyValues: "Valeurs X Y",
  paired: "Mode apparié",
  axis: "Axe",
  navigator: "Navigateur",
  color: "Couleur",
  thickness: "Épaisseur",
  xType: "Type de X",
  automatic: "Automatique",
  category: "Catégorie",
  number: "Nombre",
  time: "Heure",
  xRotation: "Rotation X",
  yRotation: "Rotation Y",
  ticks: "Graduations",
  width: "Largeur",
  height: "Hauteur",
  length: "Longueur",
  padding: "Marge intérieure",
  spacing: "Espacement",
  chart: "Graphique",
  title: "Titre",
  titlePlaceholder: "Titre du graphique - double-cliquez pour modifier",
  background: "Arrière-plan",
  font: "Police",
  top: "Haut",
  right: "Droite",
  bottom: "Bas",
  left: "Gauche",
  labels: "Libellés",
  size: "Taille",
  minSize: "Taille minimale",
  maxSize: "Taille maximale",
  legend: "Légende",
  position: "Position",
  markerSize: "Taille des marqueurs",
  markerStroke: "Contour des marqueurs",
  markerPadding: "Marge des marqueurs",
  itemSpacing: "Espacement des éléments",
  itemPaddingX: "Marge X des éléments",
  itemPaddingY: "Marge Y des éléments",
  layoutHorizontalSpacing: "Espacement horizontal",
  layoutVerticalSpacing: "Espacement vertical",
  strokeWidth: "Épaisseur du trait",
  offset: "Décalage",
  offsets: "Décalages",
  tooltips: "Infobulles",
  callout: "Étiquette",
  markers: "Marqueurs",
  shadow: "Ombre",
  blur: "Flou",
  xOffset: "Décalage X",
  yOffset: "Décalage Y",
  lineWidth: "Épaisseur de la ligne",
  normal: "Normal",
  bold: "Gras",
  italic: "Italique",
  boldItalic: "Gras italique",
  predefined: "Prédéfini",
  fillOpacity: "Opacité du remplissage",
  strokeOpacity: "Opacité du trait",
  histogramBinCount: "Nombre de classes",
  columnGroup: "Colonnes",
  barGroup: "Barres",
  pieGroup: "Camembert",
  lineGroup: "Courbe",
  scatterGroup: "X Y (nuage de points)",
  areaGroup: "Aires",
  histogramGroup: "Histogramme",
  groupedColumnTooltip: "Groupées",
  stackedColumnTooltip: "Empilées",
  normalizedColumnTooltip: "Empilées à 100 %",
  groupedBarTooltip: "Groupées",
  stackedBarTooltip: "Empilées",
  normalizedBarTooltip: "Empilées à 100 %",
  pieTooltip: "Camembert",
  doughnutTooltip: "Anneau",
  lineTooltip: "Courbe",
  groupedAreaTooltip: "Aires",
  stackedAreaTooltip: "Empilées",
  normalizedAreaTooltip: "Empilées à 100 %",
  scatterTooltip: "Nuage de points",
  bubbleTooltip: "Bulles",
  histogramTooltip: "Histogramme",
  noDataToChart: "Aucune donnée disponible pour le graphique.",
  pivotChartRequiresPivotMode: "Le graphique croisé nécessite l'activation du mode pivot.",
};
